<template>
    <resources-base-table
        :headers="headers"
        :inputs="inputs"
        :items="items"
        :editedItem="editedItem"
        :defaultItem="defaultItem"
        :modelService="modelService"
    >
        <template v-slot:form="{ localEditedItem }">
            <v-text-field v-model="localEditedItem['alias']" :label="'Alias'"></v-text-field>
            <v-text-field v-model="localEditedItem['descripcion']" :label="'Descripción'"></v-text-field>
            <v-text-field v-model="localEditedItem['year']" :label="'Año'"></v-text-field>
            <v-autocomplete
                v-model="localEditedItem.carreraId"
                :items="carreras"
                :item-text="'carrera'"
                :item-value="'id'"
                label="Carrera genérica"
                :error-messages="localEditedItem.carreraId == null ? 'Debe seleccionar una carrera genérica' : ''"
            ></v-autocomplete>

            <!-- ojo aca puede que no necesariamente vengan en el orden correcto -->
            <!-- tambien hay que manejar el caso cuando audiovisuales este vacio -->
            <!-- <v-text-field
                v-if="localEditedItem.audiovisuales[0]"
                v-model="localEditedItem.audiovisuales[0].url"
                :label="'Malla Curricular'"
            ></v-text-field>
            <v-text-field
                v-if="localEditedItem.audiovisuales[1]"
                v-model="localEditedItem.audiovisuales[1].url"
                :label="'Video'"
            ></v-text-field> -->

            <!-- <v-icon small class="mr-2" @click="addPonderacion(localEditedItem)">Agregar ponderacion</v-icon>
            <div v-if="localEditedItem.ponderaciones.length > 0">
                <span v-for="(ponderable, index) in localEditedItem.ponderaciones" :key="index">
                    <v-select
                        v-model="localEditedItem.ponderaciones[index].ponderableId"
                        :label="'Ponderables'"
                        :items="allPonderables"
                        item-text="descripcion"
                        item-value="key"
                    ></v-select>
                    <v-text-field
                        v-model="localEditedItem.ponderaciones[index].ponderacion"
                        :label="'Ponderación'"
                    ></v-text-field>
                </span>
            </div> -->
        </template>

        <template v-slot:actions="{ item }">
            <router-link :to="{ name: 'CarreraSede', params: { id: item.id } }">
                <v-icon small>Detalle</v-icon>
            </router-link>
        </template>
    </resources-base-table>
</template>

<script>
import { CarreraSedesService } from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            modelService: CarreraSedesService,
            inputs: [
                {
                    text: "Alias",
                    value: "alias"
                },
                {
                    text: "Descripción",
                    value: "descripcion"
                },
                {
                    text: "Año",
                    value: "year"
                }
            ],
            headers: [
                {
                    sortable: false,
                    text: "Alias",
                    value: "alias"
                },
                {
                    sortable: false,
                    text: "Descripción",
                    value: "descripcion"
                },
                { text: "Acciones", value: "action", sortable: false }
            ],
            editedItem: {
                sedeId: this.sedeId,
                alias: "",
                descripcion: "",
                year: "",
                audiovisuales: [{ tipoAudiovisualId: "1", url: "" }, { tipoAudiovisualId: "2", url: "" }],
                ponderaciones: []
            },
            defaultItem: {
                sedeId: this.sedeId,
                alias: "",
                descripcion: "",
                year: "",
                audiovisuales: [{ tipoAudiovisualId: "1", url: "" }, { tipoAudiovisualId: "2", url: "" }],
                ponderaciones: []
            }
        }
    },
    props: ["items", "allPonderables", "sedeId", "carreras"],
    methods: {
        addPonderacion(localEditedItem) {
            let ponderacion = { ponderableId: "", ponderacion: "" }
            localEditedItem.ponderaciones.push(ponderacion)
        }
    }
}
</script>
